import { render, staticRenderFns } from "./TeamPreviewModal.vue?vue&type=template&id=5d60a886&scoped=true"
import script from "./TeamPreviewModal.vue?vue&type=script&lang=js"
export * from "./TeamPreviewModal.vue?vue&type=script&lang=js"
import style0 from "./TeamPreviewModal.vue?vue&type=style&index=0&id=5d60a886&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d60a886",
  null
  
)

export default component.exports